/**
 * 倉別管理（store-place-mgmt）路由 — 倉別 hub + 倉別 CRUD。
 */
import { PERM, STORE_PLACE_READ_CODES } from '#/config/permissions';
import RequirePermission from '#/modules/infra/auth/RequirePermission';
import CreateEditWarehouseLocationPage from '#/modules/imsMgmt/settings/storePlace/pages/CreateEditWarehouseLocationPage';
import CreateEditWarehousePage from '#/modules/imsMgmt/settings/storePlace/pages/CreateEditWarehousePage';
import StorePlaceHubPage from '#/modules/imsMgmt/settings/storePlace/pages/StorePlaceHubPage';
import WarehouseListPage from '#/modules/imsMgmt/settings/storePlace/pages/WarehouseListPage';
import WarehouseLocationListPage from '#/modules/imsMgmt/settings/storePlace/pages/WarehouseLocationListPage';

export const storePlaceMgmtRoute = {
  path: 'store-place-mgmt',
  handle: { title: '倉別管理' },
  element: <RequirePermission codes={STORE_PLACE_READ_CODES} mode="any" />,
  children: [
    {
      index: true,
      element: (
        <RequirePermission codes={STORE_PLACE_READ_CODES} mode="any">
          <StorePlaceHubPage />
        </RequirePermission>
      ),
    },
    {
      path: 'warehouse',
      handle: { title: '倉別列表' },
      element: (
        <RequirePermission codes={STORE_PLACE_READ_CODES} mode="any" />
      ),
      children: [
        {
          index: true,
          element: <WarehouseListPage />,
        },
        {
          path: 'create',
          handle: { title: '新增倉別' },
          element: (
            <RequirePermission code={PERM.WAREHOUSE_CREATE}>
              <CreateEditWarehousePage />
            </RequirePermission>
          ),
        },
        {
          path: ':id/edit',
          handle: { title: '編輯倉別' },
          element: (
            <RequirePermission code={PERM.WAREHOUSE_UPDATE}>
              <CreateEditWarehousePage />
            </RequirePermission>
          ),
        },
      ],
    },
    {
      path: 'location',
      handle: { title: '儲位列表' },
      element: (
        <RequirePermission codes={STORE_PLACE_READ_CODES} mode="any" />
      ),
      children: [
        {
          index: true,
          element: <WarehouseLocationListPage />,
        },
        {
          path: 'create',
          handle: { title: '新增儲位' },
          element: (
            <RequirePermission code={PERM.WAREHOUSE_CREATE}>
              <CreateEditWarehouseLocationPage />
            </RequirePermission>
          ),
        },
        {
          path: ':id/edit',
          handle: { title: '編輯儲位' },
          element: (
            <RequirePermission code={PERM.WAREHOUSE_UPDATE}>
              <CreateEditWarehouseLocationPage />
            </RequirePermission>
          ),
        },
      ],
    },
  ],
};
